module.exports = __webpack_public_path__ + "media/combosmash-gameplay@xs-06461736e9a67455ca2fe9f414faec5a.gif";